import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

import { amountMaxValue } from '@rp/shared/models';

import { Validation } from './enums/validation.enum';

export const amountMaxValueValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  return control.value && Number(control.value) > amountMaxValue
    ? { [Validation.MaxAmount]: true }
    : null;
};
